export default "__VITE_ASSET__j7nuXqv2__"